import React from 'react';
import SwatchButton from './SwatchButton';
import {
  StyledButtonsWrapper,
  StyledButtonsTitle,
  StyledButtonsContainer,
} from './SwatchButtonGroup.style';

export default class SwatchButtonGroup extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { active: null };
    this.setActive = this.setActive.bind(this);
  }

  setActive(name, value) {
    const { onActiveCallback } = this.props;
    this.setState({ active: value });
    onActiveCallback(name, value);
  }

  componentDidMount() {
    const { activeDefault } = this.props;
    this.setActive(activeDefault.name, activeDefault.value);
  }

  componentDidUpdate() {
    const { activeDefault } = this.props;

    if (activeDefault) {
      this.setState({ active: activeDefault.value });
    }
  }

  render() {
    const { active } = this.state;
    const {
      option,
      styles,
      className,
      isDisabled,
    } = this.props;
    const { activeBackgroundColor, activeColor, inactiveBackgroundColor, inactiveColor } = styles;

    return (
      <StyledButtonsWrapper className={className}>
        <StyledButtonsTitle className="titles">{option.name}</StyledButtonsTitle>
        <StyledButtonsContainer>
        {
          option.values.map((v, i) => (
            <SwatchButton
              key={v}
              type="button"
              className={
                (i === 0 && 'first')
                || (i === option.values.length - 1 && 'last')
              }
              value={v}
              optionName={option.name}
              onClick={this.setActive}
              activeBackgroundColor={activeBackgroundColor}
              activeColor={activeColor}
              inactiveBackgroundColor={inactiveBackgroundColor}
              inactiveColor={inactiveColor}
              disabled={isDisabled}
              isActive={v === active}
            />
          ))
        }
        </StyledButtonsContainer>
      </StyledButtonsWrapper>
    );
  }
}
